import {
  Parser,
  Result,
  Skipper,
  parserFor,
  defaultSkip,
} from './common';

export class Repeat<T, U> implements Parser<T[]> {
  public constructor(private readonly parser: Parser<T>,
                     private readonly separator?: Parser<U>,
                     private readonly min: number = 0,
                     private readonly max: number = Infinity,
                     private readonly skip: Skipper = defaultSkip) { }

  public parse(str: string): Result<T[]> {
    const { parser, separator, min, max, skip } = this;
    const value: T[] = [];
    let next = str;
    let i = 0;
    while (i < max) {
      const r = parser.parse(next);
      if (r === undefined) {
        break;
      }
      const n = skip(r.next);
      if (n.length === next.length) {
        break;
      }
      value.push(r.value);
      next = n;
      i += 1;
      if (separator !== undefined) {
        const s = separator.parse(next);
        if (s === undefined) {
          break;
        }
        next = skip(s.next);
      }
    }
    if (i < min) {
      return;
    }
    return { value, next };
  }
}

export function rep<T, U>(parser: Parser<T>,
                          separator: Parser<U>,
                          min?: number,
                          max?: number,
                          skip?: Skipper): Repeat<T, U>;
export function rep<T>(parser: Parser<T>,
                       separator?: any,
                       min?: number,
                       max?: number,
                       skip?: Skipper): Repeat<T, any>;
export function rep<T>(parser: any,
                       separator: Parser<T>,
                       min?: number,
                       max?: number,
                       skip?: Skipper): Repeat<any, T>;
export function rep(parser: any,
                    separator?: any,
                    min?: number,
                    max?: number,
                    skip?: Skipper): Repeat<any, any>;
export function rep(parser: any,
                    separator?: any,
                    min?: number,
                    max?: number,
                    skip?: Skipper): Repeat<any, any> {
  return new Repeat(parserFor(parser, skip),
                    separator !== undefined ? parserFor(separator) : undefined,
                    min,
                    max,
                    skip);
}
